<template>
  <b-collapse id="contact-us">
    <b-card class="mb-0">
      <span v-b-toggle.contact-us id="closeBtn"><i class="fas fa-times fa-2x"></i></span>
      <b-form>
        <b-form-group label="Name:" label-for="contact-name">
          <b-form-input id="contact-name" v-model="form.name" placeholder="Enter name" required></b-form-input>
        </b-form-group>
        <b-form-group label="Email:" label-for="contact-email">
          <b-form-input id="contact-email" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
        </b-form-group>
        <b-form-group label="What are you contacting about?" label-for="contact-category">
          <b-form-select v-model="form.category" :options="options"></b-form-select>
        </b-form-group>
        <b-form-group label="Message:" label-for="contact-message">
          <b-form-textarea id="contact-message" v-model="form.message" placeholder="Message..." rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>
        <b-button block variant="danger" @click="send">Send</b-button>
      </b-form>
    </b-card>
  </b-collapse>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  data: function() {
    return {
      form: {
        name: null,
        email: null,
        category: 0,
        message: null
      },
      options: [
        { value: '0', text: 'Account Support' },
        { value: '1', text: 'Technical Support' },
        { value: '2', text: 'New Feature' }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.getters['profile/user']
    }
  },
  methods: {
    send() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/contact-support", this.form)
        .then(response => {
          this.form.category = 0;
          this.form.message = null;
          this.$root.$emit('bv::toggle::collapse', 'contact-us');
          this.success(response);
        })
        .catch(error => {
          this.error(error);
        });
    },
    success(response) {
      swal.fire({
        title: `Success`,
        text: response.data,
        showConfirmButton: false,
        timer: 1750,
        icon: 'success'
      });
    },
    error(error) {
      swal.fire({
        title: `Error`,
        text: error.data,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        icon: 'warning'
      });
    },
  },
  created() {
    this.form.name = this.user.name;
    this.form.email = this.user.email;
  }
};
</script>
<style>
  #contact-us {
    position: fixed;
    bottom: 0;
    right: 10px;
  }
  #contact-us #closeBtn {
    position: absolute;
    right: 8px;
    top: 5px;
    color: #dc3545;
  }
</style>